/* eslint-disable prettier/prettier */
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as CONFIG from "../../../config.json";
import * as SUBMITTED_LIST_ACTIONS from "./actionCreators";
import * as myCartActionCreators from "../MyCart/actionCreators";
import * as ACTIONS from "../ThankYou/actionCreators";
import {
    dateFormatter,
    getPersistData,
    setPersistData,
    setSessionValue,
} from "../../utils/utils";
import ReviewPopup from "../MyCart/ReviewPopup";
import constantFile from "../../constants/constantFile";
import { PersistData } from "../../middleware/persistDataMiddleware";
import { COPY_WARRANTY_DATA, CREATE_ANOTHER } from "../../constants/storageKeys";
import Loader from "../Loader";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const Loadable = require("react-loadable");
const BSTable = Loadable({
    loader: () => import("../BSTable"),
    loading() {
        return <div>Loading...</div>;
    },
});

const Filters = Loadable({
    loader: () => import("./WarrantiesFilters"),
    loading() {
        return <div>Loading...</div>;
    },
});

interface ISubmittedWarrantyListProps {
    screenResolution: Record<string, number>;
    submittedWarranties?: Array<any>;
    activeTab: string;
    userInfo?: any;
    copyWarranty: any;
    reviewData?: any;
    isLoading?: boolean;
    isDownloading?: boolean;
    submittedListActions: any;
    myCartActions?: any;
    generateFullWarrantyPdf: any;
    generateSummaryWarrantyPdf: any;
    downloadWarrantySummaryPdf?: any;
    onTableRowSelection?: any;
    onTableRowClick?: any;
}
class SubmittedWarranties extends React.Component<ISubmittedWarrantyListProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            openReviewPopup: false,
            enableLoader: false,
        };
        this.prepareTableData = this.prepareTableData.bind(this);
        this.dateSortFunc = this.dateSortFunc.bind(this);
        this.ownerSortFunc = this.ownerSortFunc.bind(this);
    }
    componentDidMount(): void {
        const { fetchSubmittedWarrentyList, fetchStateProviceList } = this.props.submittedListActions;
        if (this.props.activeTab === "submitted") {
            fetchSubmittedWarrentyList({});
            fetchStateProviceList(0);
        }
    }
    componentDidUpdate(prevProps, prevState): void {
        const { fetchSubmittedWarrentyList, fetchStateProviceList } = this.props.submittedListActions;
        if (
            prevProps.activeTab !== this.props.activeTab &&
            this.props.activeTab === "submitted" &&
            !this.props.submittedWarranties.length
        ) {
            fetchSubmittedWarrentyList({});
            fetchStateProviceList(0);
        }
        if (this.props.isLoading != prevProps.isLoading && this.props.isLoading) {
            this.setState({
                enableLoader: true,
            });
        }
    }
    // date and time sort function for create and update
    dateSortFunc(a, b, order, dataField, rowA, rowB) {
        const updateDateTime = {};
        window["AppInsightTrace"].trackEvent(`clicked on date and time sort`);
        this.props.submittedWarranties.map((submittedItem) => {
            updateDateTime[submittedItem.id] = submittedItem.postedDate;
        });
        return updateDateTime[b.id];
    }

    // Sort the owner column using lastName+firstName
    ownerSortFunc(a, b) {
        const updateOwnerInfo = {};
        this.props.submittedWarranties.map((submittedItem) => {
            updateOwnerInfo[submittedItem.id] = submittedItem.owner
                ? submittedItem.owner.lastName + submittedItem.owner.firstName
                : "";
        });
        return updateOwnerInfo[b.id];
    }
    downloadFullPdf = (obj) => {
        const { generateFullWarrantyPdf, isDownloading } = this.props;
        if (!isDownloading) generateFullWarrantyPdf(obj.id, obj.warrantyNum);
    };
    downloadSummaryPdf = (obj) => {
        const { downloadWarrantySummaryPdf, isDownloading } = this.props;
        if (!isDownloading) downloadWarrantySummaryPdf(obj.id, obj.warrantyNum);
    };
    popupWindow = (url, windowName, win, w, h) => {
        const y = ((win.top.outerHeight / 2) + win.top.screenY) - (h / 2);
        const x = ((win.top.outerWidth / 2) + win.top.screenX) - (w / 2);
        let width = w;
        let height = h;
        if (x < 0) {
            width = 1080;
            height = 800;
        }
        return win.open(
            url,
            windowName,
            `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${y}, left=${x}`
        );
    };
    openPaymentReceiptTab = (obj) => {
        let w = 400;
        let h = 400; // default sizes
        const popupWinWidth = 632;
        const popupWinHeight = 500;
        w = popupWinWidth + 30;
        h = popupWinHeight + 30;
        // window.open(`/receipt/${transactionId}`, "Payment Receipt", 'location=no,width=' + w + ',height=' + h + ',menubar=no,scrollbars=no,frame=false');
        this.popupWindow(
            `${CONFIG.CONFIG.pdReceiptUrl}/receipt/${obj.pdTransactionId}`,
            "Payment Receipt",
            window,
            w,
            h
        );
    };
    copyWarranty = (obj) => {
        console.log("Copying ...", obj);
        const warrantyId = obj.id;
        let persistData: PersistData = getPersistData() || {};
        persistData = Object.assign(persistData, {
            warrantyId,
        });
        setSessionValue(COPY_WARRANTY_DATA, "true");
        setSessionValue(CREATE_ANOTHER, "true");
        setPersistData(persistData);
        this.props.copyWarranty();
    };
    rankFormatter = (cell, row, rowIndex) => {
        const hideDownload = !row.canGenerateReport ? "invisible" : "";
        const hideReceipt = !row.pdTransactionId ? "invisible" : "";
        return (
            <div
                id={`actions-row-${row.id}`}
                className="actions-icons"
                onClick={(e) => {
                    e.stopPropagation();
                    // this.onTableRowDelete(row);
                }}
            >
                <div className="copy-btn-with-icon" title="Copy">
                    <a onClick={() => this.copyWarranty(row)}></a>
                </div>
                <div className="download-summary-with-icon" title="Download Summary">
                    <a onClick={() => this.downloadSummaryPdf(row)}></a>
                </div>
                <div className={`download-btn-with-icon ${hideDownload}` } title="Download Full Warranty">
                    <a onClick={() => this.downloadFullPdf(row)}></a>
                </div>
                <div className={`payment-receipt-icon ${hideReceipt}`} title="Payment Receipt">
                    <a onClick={() => this.openPaymentReceiptTab(row)}></a>
                </div>
            </div>
        );
    };

    prepareTableData(tableRecords) {
        const BSTableData = [];
        tableRecords
            .sort((a, b) => {
                const dateA: any = new Date(a.updatedDate);
                const dateB: any = new Date(b.updatedDate);
                return dateB - dateA;
            })
            .forEach((submittedItem) => {
                const newItem = {};
                newItem["id"] = submittedItem.id;
                newItem["warrantyNum"] = submittedItem.warrantyNumber;
                 // newItem["warrantyId"] = <a className="review-link" onClick={() => this.onReviewClick(submittedItem)}>{submittedItem.id}</a>;
                newItem["warrantyNumber"] = <a className="review-link" onClick={() => this.onReviewClick(submittedItem)}>{submittedItem.warrantyNumber}</a>;
                newItem["cartId"] = !!submittedItem.shoppingCartId ? submittedItem.shoppingCartId : "";
                const seperator =
                    submittedItem.owner && submittedItem.owner.lastName && submittedItem.owner.firstName ? ", " : "";
                newItem["buildingAddress"] = submittedItem.buildingAddress.addressLine1;
                newItem["owner"] = submittedItem.owner
                    ? submittedItem.owner.lastName + seperator + submittedItem.owner.firstName
                    : "";
                newItem["region"] = submittedItem.buildingAddress
                    ? submittedItem.buildingAddress.city + ", " + submittedItem.buildingAddress.state
                    : "";
                newItem["warrantyType"] = submittedItem.warrantyType;
                newItem["canGenerateReport"] = submittedItem.canGenerateReport;
                newItem["forminstanceTypeId"] = submittedItem.forminstanceTypeId;
                newItem["status"] = submittedItem.status;
                newItem["fee"] = `${submittedItem.fee}.00`;
                newItem["postedDate"] = dateFormatter(submittedItem.postedDate);
                newItem["pdTransactionId"] = submittedItem.paymentDirectorTransactionId;
                newItem["actions"] = "Actions";
                BSTableData.push(newItem);
            });
        if (this.state.enableLoader && !this.props.isLoading){
            setTimeout(() => this.setState({
                enableLoader: false,
            }), 1500);
        }
        return BSTableData;
    }
    renderActions = (tableItem) => {
        const hideDownload = !tableItem.canGenerateReport ? "invisible" : "";
        const hideReceipt = !tableItem.pdTransactionId ? "invisible" : "";
        return (<div
            className="delete-btn-menu actions-icons"
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <div className="copy-btn-with-icon" title="Copy">
                <a onClick={() => this.copyWarranty(tableItem)}></a>
            </div>
            <div className="download-summary-with-icon" title="Download Summary">
                <a onClick={() => this.downloadSummaryPdf(tableItem)}></a>
            </div>
            <div className={`download-btn-with-icon ${hideDownload}`} title="Download Full Warranty">
                <a onClick={() => this.downloadFullPdf(tableItem)}></a>
            </div>
            <div className={`payment-receipt-icon ${hideReceipt}`} title="Payment Receipt">
                <a onClick={() => this.openPaymentReceiptTab(tableItem)}></a>
            </div>
        </div>);
    };
    onReviewClick = (obj) => {
        window.scrollTo(0, 0);
        this.setState({
            openReviewPopup: true,
        });
        this.props.myCartActions.reviewWarrantyData(obj.id);
    };
    onCancelAction = () => {
        this.setState({
            openReviewPopup: false,
        });
    };
    render() {
        const BSTableData = this.prepareTableData(this.props.submittedWarranties);
        constantFile.submittedGridColumns[8]["formatter"] = this.rankFormatter;
        constantFile.submittedGridColumns[7]["sortValue"] = this.dateSortFunc;
        constantFile.submittedGridColumns[5]["sortValue"] = this.ownerSortFunc;

        const tableColumns = constantFile.submittedGridColumns;
        const defaultSorted = constantFile.draftTableDefaultSorted;
        const displayClass = BSTableData.length === 0 ? "invisible" : "visible";
        return (
            <React.Fragment>
                {this.state.openReviewPopup && Object.keys(this.props.reviewData).length ? (
                        <ReviewPopup onCancel={this.onCancelAction} />
                    ) : null}
                <div className="submitted-list">
                    <Filters />
                    <div className="form-subtitle">
                        {this.state.enableLoader || this.props.isLoading
                            ? (<Loader />)
                            : !this.props.isLoading && !this.state.enableLoader && BSTableData.length === 0
                            ? "Sorry, we couldn't find any search results. Please change the search criteria and try again."
                            : ""}
                    </div>
                    <div className={displayClass}>
                        {this.props.screenResolution.width >= 768 && (
                            <div>
                                <BSTable
                                    hover
                                    striped
                                    sortable
                                    bordered={false}
                                    defaultSorted={defaultSorted}
                                    tableColumnData={tableColumns}
                                    tableRowData={BSTableData}
                                    tableRowClick={() => {}}
                                    // tableRowDelete={this.onTableRowDelete}
                                />
                            </div>
                        )}
                        {this.props.screenResolution.width < 768 && (
                            <div>
                                <div className="item-list">
                                    {BSTableData.map((tableItem, index) => {
                                        return (
                                            <div
                                                id={`table-row-id-${tableItem.id}`}
                                                key={`menuitem${index}`}
                                                className={`item menu-item table-row-id-${tableItem.id}`}
                                                // onClick={() => this.props.onTableRowClick(tableItem)}
                                            >
                                                <div className="mobile-menu-item">
                                                    <div>{tableItem.warrantyId}</div>
                                                    <div className="item-cost">${tableItem.fee}</div>
                                                </div>
                                                <div className="mobile-menu-item">
                                                    <div>{tableItem.buildingAddress}</div>
                                                </div>
                                                <div className="mobile-menu-item">
                                                    <div>{tableItem.postedDate}</div>
                                                    <div>{this.renderActions(tableItem)}</div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state) {
    return {
        userInfo: state.adminData.userInfo,
        screenResolution: state.globalInfo.screenResolution,
        submittedWarranties: state.submittedListInfo.submittedList || [],
        isDownloading: state.payments.isDownloading || false,
        reviewData: state.myCartInfo.reviewData || {},
        activeTab: state.submittedListInfo.activeTab,
        isLoading: state.submittedListInfo.isLoading || false,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        submittedListActions: bindActionCreators(SUBMITTED_LIST_ACTIONS, dispatch),
        myCartActions: bindActionCreators(myCartActionCreators, dispatch),
        generateFullWarrantyPdf: bindActionCreators(ACTIONS.generateFullWarranty, dispatch),
        generateSummaryWarrantyPdf: bindActionCreators(ACTIONS.generateSummaryWarranty, dispatch),
        downloadWarrantySummaryPdf: bindActionCreators(ACTIONS.downloadSummaryPdf, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmittedWarranties);
